<template>
  <el-popover
    trigger="click"
    placement="left"
    :disabled="adminAjaxing || disabled"
    v-model="showMenu"
    width="100px"
    @show="handlePopoverShow">
    <div>
      <div v-if="passbackLinking" class="action-button">
        <v-btn
          flat
          text
          class="branded-grey"
          @click="passbackContent({bulbId: bulb.id, bulbName: bulb.name, type: 'bulb'}); showMenu = false;"
          tabindex="0">
          <v-icon small class="pr-1">exit_to_app</v-icon> Passback Bulb
        </v-btn>
      </div>
      <div class="action-button" v-if="!isPlaylist">
       <div class="action-button" v-if="LTIlaunch && LTIdata.contentId === null && bulb.list_code != 0">
          <v-btn flat text  class="branded-grey"  @click="openOldModal({type:'lti' , data: bulb})" >
            <img class="lms-img-sm" :src="LMSdata.img">
            <span class="pl-1">Set Bulb Link</span>
          </v-btn>
        </div>
        <div class="action-button" v-if="LTIlaunch && LTIdata.contentId == bulb.id && bulb.list_code != 0">
          <v-btn flat text  class="branded-grey"  @click="setDashModal({ type: 'confirmUnlink' }); showMenu = false;" >
            <img class="lms-img-sm" :src="LMSdata.img">
            <span class="pl-1">Unlink Bulb</span>
          </v-btn>
        </div>
        <v-divider v-if="LTIlaunch"></v-divider>
        <v-btn flat text class="branded-grey"  @click="openOldModal({type:'bulbInfo' , data:bulb})" tabindex="0">
          <v-icon small  class="pr-1">settings</v-icon>
          Settings
        </v-btn>
      </div>
      <div class="action-button">
        <v-btn flat text  class="branded-grey"  @click="editContent()" tabindex="0">
          <v-icon small class="pr-1">edit</v-icon>
          Edit
        </v-btn>
      </div>
      <div class="action-button">
        <v-btn flat text  class="branded-grey"  @click="playContent()" tabindex="0">
          <v-icon small class="pr-1">play_circle_outline</v-icon>
          Preview
        </v-btn>
      </div>
      <div class="action-button" v-if="isPlaylist">
        <v-btn flat @click="handleDuplicatePlaylist()" text class="branded-grey">
          <v-icon small class="pr-1">content_copy</v-icon>
          Duplicate
        </v-btn>
      </div>
      <div class="action-button">
        <v-btn
          flat
          text
          class="branded-grey"
          @click="handleAdminCollaborate">
          <v-icon
            small
            class="pr-1">
            group
          </v-icon>
          Collaborate
        </v-btn>
      </div>
      <div class="action-button" v-if="!isPlaylist">
        <v-btn
          flat
          text 
          class="branded-grey"
          @click="openNewModal({ 
            type: 'sectionInfo',
            bulbId: bulb.id,
            admin: true 
          })"
        >
          <v-icon small class="pr-1">info</v-icon>
          Bulb Details
        </v-btn>
      </div>
      <div class="action-button" v-if="!isPlaylist">
        <v-btn
          flat
          text
          class="branded-grey"
          tabindex="0"
          @click="exportAnalytics({
            type:'export',
            data: {
              analytics:true,
              bulb_name:bulb.name,
              bulb_id:bulb.id
            }
          })"
        >
          <v-icon small class="pr-1">cloud_download</v-icon>
          Export Analytics
        </v-btn>
      </div>
      <div class="action-button" v-if="isPlaylist">
        <v-btn 
          flat
          text 
          class="branded-grey"
          tabindex="0"
          @click="exportAnalytics({
            type:'export', 
            data: { 
              playlistAnalytics:true,
              playlist_name:playlist.name,
              playlist_id:playlist.id 
            }
          })"
        >
          <v-icon small class="pr-1">cloud_download</v-icon>
          Export Analytics
        </v-btn>
      </div>
      <div class="action-button" v-if="!isPlaylist">
        <v-btn
          flat
          text
          class="branded-grey"
          @click="exportWorksheet(bulb.id)"
        >
          <v-icon small class="pr-1">description</v-icon>
          Export Worksheet
        </v-btn>
      </div>
      <div class="action-button" v-if="!isPlaylist">
        <v-btn
          flat
          text
          class="branded-grey"
          tabindex="0"
          @click="openOldModal({
            type:'copyMenu',
            data: bulb
            })"
          >
          <v-icon small class="pr-1">file_copy</v-icon>
          Copy
        </v-btn>
      </div>
      <div class="action-button admin-action-button-bulb-delete"> 
        <v-btn
          flat
          text
          class="branded-grey"
          @click="deleteContent()">
            <v-icon small class="pr-1">delete</v-icon>
            Delete
        </v-btn>
      </div>
    </div>
    <div v-if="thumbnail" slot="reference" class="column" style="height:50px;">
       <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px" >
        <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="thumbnail"/></button>
      </v-responsive>
    </div>
    <div v-if="icon" flat class="no-hover" slot="reference" >
      <v-icon
        class="hover-white cursor padding"
        :class="{'branded-text': icon !== 'playlist_play'}"
        :large="icon === 'playlist_play'"
        :color="isPlaylist ? playlist.defaultColor : ''">{{icon}}</v-icon>
    </div>
  </el-popover>
</template>

<script>
/* global _ */
/* global moment */
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';
import {
  getServerUrl,
} from '@utilities';

export default {
  name: 'AdminTableActionMenu',
  props: [ 
    'bulb',
    'disabled',
    'handlePopoverShow',
    'icon',
    'playlist',
    'thumbnail',
  ],
  data() {
    return {
      actionMenuStyle: {
        'padding': !this.isPlaylist,
        'branded-text': !this.isPlaylist,
      },
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminAjaxing',
      'instructorData',
      'LTIdata',
      'LMSdata',
      'LTIlaunch',
      'passbackLinking',
      'playerApiPrefix',
      'school'
    ]),
    ...mapGetters('admin', [
      'adminAjaxing',
    ]),
    isPlaylist() {
      return !!this.playlist;
    },
  },
  methods: {
    ...mapActions([
      'passbackContent',
    ]),
    ...mapActions('admin', [
      'launchAdminPlaylist',
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
    ]),
    editContent() {
      if (!this.isPlaylist) {
        this.setDashModal({
          type: 'confirmEditBulb',
          bulbId: this.bulb.id,
          admin: true,
        });
        this.showMenu = false;
      } else {
        this.launchAdminPlaylist({
          playlistId: this.playlist.id,
          preview: false,
        });
      }
    },
    exportAnalytics(props){
      this.showMenu = false;
      this.handleDialogOpen(props);
    },
    async exportWorksheet(bulbId) {
      this.showMenu = false; // element is stupid and doesn't have a prop to close on click
      const baseURL = getServerUrl();
      const win = window.open(`${baseURL}print?type=worksheet&bulb_id=${bulbId}`);
      win.focus();
    },
    async handleDuplicatePlaylist() {
      this.setDashModal({ type: 'duplicatePlaylist', playlist: this.playlist });
      this.showMenu = false; // el-popover is dumb and won't close
    },
    handleAdminCollaborate() {
      if (this.bulb) {
        this.setDashModal({ type: 'adminBulbCollaborate', bulb: this.bulb })
      } else this.setDashModal({ type: 'playlistCollaborate', playlist: this.playlist })
    },
    openOldModal(props) {
      this.showMenu = false; // element is stupid and doesn't have a prop to close on click
      this.handleDialogOpen(props);
    },
    openNewModal(props) {
      this.showMenu = false;  // element is stupid and doesn't have a prop to close on click
      this.setDashModal(props)
    },
    deleteContent() {
      if (!this.isPlaylist) {
        this.setDashModal({
          type: 'confirmDeleteBulb',
          bulb: this.bulb,
          admin: true,
        });
        this.showMenu = false;
      } else {
        this.setDashModal({
          type: 'confirmDeletePlaylist',
          playlist: this.playlist,
        });
        this.showMenu = false;
      }
    },
    playContent() {
      if (!this.isPlaylist) {
        this.showMenu = false; // element is stupid and doesn't have a prop to close on click
        window.open(`${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${this.bulb.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
      } else {
        this.launchAdminPlaylist({
          playlistId: this.playlist.id,
          preview: true,
        });
      }
    },
  },
};
</script>

<style>
.admin-action-button-bulb-delete button:hover i {
  color: red !important;
}
</style>
